import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "update-available",
  role: "status",
  "aria-live": "polite",
  "aria-label": "Application update available"
}
const _hoisted_2 = { class: "update-available__actions" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

import { onMounted, onUnmounted, ref } from 'vue';
import {
  UPDATE_AVAILABLE_EVENT,
  UPDATE_FAILED_EVENT,
  UPDATE_STARTED_EVENT,
  versionManager
} from '@/modules/updates/versionManager';
import type { UpdateAvailableDetail } from '@/modules/updates/versionManager';

const DISMISSED_KEY = 'JIDOKA_DISMISSED_BUILD';

export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateAvailable',
  setup(__props) {

const visible = ref(false);
const refreshing = ref(false);

const show = (event?: Event) => {
  const detail = (event as CustomEvent<UpdateAvailableDetail> | undefined)?.detail;
  const buildId = detail?.availableBuildId || versionManager.availableBuildId;
  if (buildId && sessionStorage.getItem(DISMISSED_KEY) === buildId) return;
  visible.value = true;
};
const dismiss = () => {
  if (versionManager.availableBuildId) sessionStorage.setItem(DISMISSED_KEY, versionManager.availableBuildId);
  visible.value = false;
};
const markStarted = () => { refreshing.value = true; visible.value = true; };
const markFailed = () => { refreshing.value = false; };
const refresh = () => { void versionManager.refreshToLatest(); };

onMounted(() => {
  window.addEventListener(UPDATE_AVAILABLE_EVENT, show);
  window.addEventListener(UPDATE_STARTED_EVENT, markStarted);
  window.addEventListener(UPDATE_FAILED_EVENT, markFailed);
  if (versionManager.availableBuildId && versionManager.availableBuildId !== versionManager.currentBuildId) show();
});

onUnmounted(() => {
  window.removeEventListener(UPDATE_AVAILABLE_EVENT, show);
  window.removeEventListener(UPDATE_STARTED_EVENT, markStarted);
  window.removeEventListener(UPDATE_FAILED_EVENT, markFailed);
});

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("span", {
          class: "update-available__icon icon-update-21",
          "aria-hidden": "true"
        }, null, -1 /* CACHED */)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "update-available__content" }, [
          _createElementVNode("strong", null, "New version of Jidoka available"),
          _createElementVNode("span", null, "Refresh to load the latest version")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "button pill -text",
            disabled: refreshing.value,
            onClick: dismiss
          }, "Later", 8 /* PROPS */, _hoisted_3),
          _createElementVNode("button", {
            type: "button",
            class: "button pill -blue",
            disabled: refreshing.value,
            onClick: refresh
          }, _toDisplayString(refreshing.value ? 'Refreshing…' : 'Refresh now'), 9 /* TEXT, PROPS */, _hoisted_4)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})